import MainLayout from "../layouts/MainLayout";
// import Home from "../pages/Home";
import Logout from "../pages/Logout"

import { ComponentType } from "react";
import Sponsorships from "../pages/Sponsorships";
import NotFound from "../pages/system/NotFound";
// import ConnectIGStatus from "../pages/auth/ConnectIGStatus";
import Campaign from "../pages/Campaign";
import Profile from "../pages/Profile";
import Referral from "../pages/Referral";
import Membership from "../pages/Membership";
import Wallet from "../pages/Wallet";
import CampaignPublic from "../pages/public/Campaign";
import PublicLayout from "../layouts/PublicLayout";
import DMAutomations from "../pages/DMAutomations";
import { CAP_IG_AUTH_REDIRECT_ROUTE, IG_AUTH_REDIRECT_ROUTE, IG_HANDLE_INPUT_ROUTE, IG_HANDLE_VERIFICATION_ROUTE, INIT_IG_AUTH_ROUTE } from "../constants/constants";
import ConnectIGRedir from "../pages/auth/ConnectIGRedir";
import CollaborationMilestones from "../pages/CollaborationMilestones";
import CollaborationMilestone from "../pages/CollaborationMilestone";
import ConversionCampaigns from "../pages/ConversionCampaigns";
import ConversionCampaign from "../pages/ConversionCampaign";
import Register from "../pages/auth/Register";
import Login from "../pages/auth/Login";
import ConnectIG from "../pages/auth/ConnectIG";
import ConnectIGHandle from "../pages/auth/ConnectIGHandle";
import ConnectIGHandleVerify from "../pages/auth/ConnectIGHandleVerify";
import CollaborationsNew from "../pages/CollaborationsNew";
import BrowserPermissionHelp from "../pages/BrowserPermissionHelp";
import CollaborationChat from "../pages/CollaborationChat";
import SocialAccount from "../pages/SocialAccount";
import PricingPublic from "../pages/public/Pricing";
import AccountDeletion from "../pages/public/AccountDeletion";
import Pricing from "../pages/Pricing";
import ConnectIGRedirCap from "../pages/auth/ConnectIGRedirCap";
import AppReview from "../pages/AppReview";
import { isNativePlatform } from "../utils/platformUtil";

export interface Route {
    path: string; // The route's path
    element: React.FC; // The component to render
    title?: string; // Title of the route
    layout?: ComponentType<any> | null; // Layout for the route; null means no layout
    authRequired?: boolean; // Indicates if authentication is required
    cache?: boolean; // Determines if the route should use caching
    children?: Route[]; // Nested routes
    showBackButton?: boolean,
    redirect?: string,
    [key: string]: any; // Allow additional custom properties
}

export const routes: Route[] = [
    {
        path: "/login",
        element: Login,
        title: "Login",
    },
    {
        path: "/register",
        element: Register,
        title: "Register",
    },
    {
        path: INIT_IG_AUTH_ROUTE,
        element: ConnectIG,
        title: 'Connect Instagram'
    },
    {
        path: IG_AUTH_REDIRECT_ROUTE,
        element: ConnectIGRedir,
        title: 'Connect Instagram'
    },
    {
        path: CAP_IG_AUTH_REDIRECT_ROUTE,
        element: isNativePlatform() ? ConnectIGRedir : ConnectIGRedirCap,
        title: 'Connect Instagram'
    },
    {
        path: IG_HANDLE_INPUT_ROUTE,
        element: ConnectIGHandle,
        title: 'Connect Instagram'
    },
    {
        path: IG_HANDLE_VERIFICATION_ROUTE,
        element: ConnectIGHandleVerify,
        title: 'Connect Instagram'
    },
    // {
    //     path: "/c/ig/status",
    //     element: ConnectIGStatus,
    //     title: 'Instagram Connection Status'
    // },
    {
        path: "/logout",
        element: Logout,
        title: "Logout"
    },
    {
        path: "/app-review",
        element: AppReview,
        title: "AppReview",
    },
    {
        path: "/",
        element: MainLayout,
        authRequired: true,
        children: [
            {
                path: "/",
                parent: 'dashboard',
                element: Sponsorships,
            },
            {
                path: "/campaign",
                parent: 'dashboard',
                element: Sponsorships,
            },
            {
                path: "/campaign/:campaignId",
                parent: 'dashboard',
                element: Campaign,
                title: "Campaign",
            },
            {
                path: "/i/me",
                parent: 'dashboard',
                element: Profile,
                title: "My Profile"
            },
            {
                path: "/i/me/collaboration",
                parent: 'dashboard',
                element: CollaborationsNew,
                redirect: '/collaborations',
                title: "Collaborations"
            },
            {
                path: "/collaborations",
                parent: 'dashboard',
                element: CollaborationsNew,
                title: "Collaborations"
            },
            {
                path: "/applications",
                parent: 'dashboard',
                element: CollaborationsNew,
                title: "Collaborations"
            },
            {
                path: "/collaborations/:campaignId",
                parent: 'dashboard',
                element: CollaborationMilestones,
                title: "Collaboration Milestones"
            },
            {
                path: "/collaborations/:campaignId/milestone/:milestoneId",
                parent: 'dashboard',
                element: CollaborationMilestone,
                title: "Milestone"
            },
            {
                path: "/chat",
                parent: 'dashboard',
                element: CollaborationChat,
                title: "Chats"
            },
            {
                path: "/chat/:uuid",
                parent: 'dashboard',
                element: CollaborationChat,
                title: "Chats"
            },
            {
                path: '/referral',
                parent: 'dashboard',
                element: Referral,
                title: 'Refer and Earn'
            },
            {
                path: "/i/me/membership",
                parent: 'dashboard',
                element: Membership,
                redirect: '/membership',
                title: "Membership"
            },
            {
                path: '/membership',
                parent: 'dashboard',
                element: Membership,
                title: 'Membership'
            },
            {
                path: '/i/pricing',
                parent: 'dashboard',
                element: Pricing,
                title: "Pricing"
            },
            {
                path: '/i/me/wallet',
                parent: 'dashboard',
                element: Wallet,
                title: 'Wallet'
            },
            {
                path: '/wallet',
                parent: 'dashboard',
                element: Wallet,
                title: 'Wallet'
            },
            {
                path: '/smart-links',
                parent: 'dashboard',
                element: DMAutomations,
                title: 'Smart Links'
            },
            {
                path: "/conversion",
                parent: 'dashboard',
                element: ConversionCampaigns,
                title: 'Share and Earn'
            },
            {
                path: "/conversion/:campaignId",
                parent: 'dashboard',
                element: ConversionCampaign,
            },
            {
                path: "/help/location",
                parent: "dashboard",
                element: BrowserPermissionHelp,
                title: 'Help - Location'
            },
            {
                path: "/i/social-account/:socialAccountId",
                parent: 'dashboard',
                element: SocialAccount,
                title: "Account Details"
            },
            {
                path: "*",
                parent: 'dashboard',
                element: NotFound,
                showBackButton: true,
            }
        ],
    },
    {
        path: "/",
        element: PublicLayout,
        children: [
            {
                path: "/c/:campaignId",
                element: CampaignPublic,
                title: "Campaign",
            },
            {
                path: "/pricing",
                element: PricingPublic,
                title: "Membership",
            },
            {
                path: "/delete-account",
                element: AccountDeletion,
                title: "Delete Account"
            }
        ]
    },

];